import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { motion } from 'framer-motion';

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-30px' }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
    >
      <Card className="group h-full flex flex-col hover:shadow-xl hover:border-primary/30 transition-all duration-300">
        <CardContent className="flex flex-col h-full p-5">
          {/* Manufacturer Badge */}
          <div className="flex items-center justify-between mb-4">
            <Badge variant="secondary" className="text-xs font-medium">
              {product.manufacturer}
            </Badge>
            <Badge variant="outline" className="text-xs">
              {product.type}
            </Badge>
          </div>

          {/* Product Name */}
          <h3 className="text-base font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
            {product.name}
          </h3>

          {/* Description */}
          <p className="text-sm text-muted-foreground mb-4 flex-grow line-clamp-2">
            {product.description}
          </p>

          {/* CTA */}
          <Button asChild variant="outline" size="sm" className="w-full mt-auto">
            <Link to={`/contact?interest=Product+Inquiry&product=${encodeURIComponent(product.name)}&manufacturer=${encodeURIComponent(product.manufacturer)}`}>
              Request Quote
            </Link>
          </Button>
        </CardContent>
      </Card>
    </motion.div>
  );
};
